import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
    selector: 'input[anySpace]'
})
export class AnySpaceDirective {

    constructor(private _el: ElementRef) { }

    @HostListener('input', ['$event']) onInputChange(event) {
        const initalValue = this._el.nativeElement.value;
        this._el.nativeElement.value = initalValue.replace(/\s/, '');
        if (initalValue !== this._el.nativeElement.value) {
            event.stopPropagation();
        }
    }

}

